import { Navigate, useLocation, useParams } from 'react-router-dom';
import { ORDER_CREATE_DRAWER_PARAM } from '../lib/order-create-drawer-url';

/** Back-compat redirect for legacy `/work-orders/:id` bookmarks and alerts. */
export function WorkOrderDetailLegacyRedirect() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/orders" replace />;
  return <Navigate to={`/orders/${id}`} replace />;
}

/** Back-compat redirect for legacy `/work-orders/new?…` create shortcuts. */
export function WorkOrderCreateLegacyRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set(ORDER_CREATE_DRAWER_PARAM, '1');
  return <Navigate to={`/orders?${params.toString()}`} replace />;
}

/**
 * @deprecated Create intent is handled by `useOrderCreateDrawer` on the list page.
 * Kept as a no-op so existing imports do not break during the drawer cutover.
 */
export function OrderListCreateIntentRedirect() {
  return null;
}
